import { httpClient } from '@/services/http/httpClient'

export async function likeVideo(videoId: number) {
  await httpClient.put('/users/videos/like', {
    videoId,
  })
}
